import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import app from 'flarum/admin/app';
import SelectDropdown from 'flarum/common/components/SelectDropdown';
import Button from 'flarum/common/components/Button';
import abbreviateNumber from 'flarum/common/utils/abbreviateNumber';
import extractText from 'flarum/common/utils/extractText';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Placeholder from 'flarum/common/components/Placeholder';
import Icon from 'flarum/common/components/Icon';
import classList from 'flarum/common/utils/classList';
import DashboardWidget from 'flarum/admin/components/DashboardWidget';
import StatisticsWidgetDateSelectionModal from './StatisticsWidgetDateSelectionModal';
import dayjs from 'dayjs';
import dayjsUtc from 'dayjs/plugin/utc';
import dayjsLocalizedFormat from 'dayjs/plugin/localizedFormat';
// @ts-expect-error No typings available
import { Chart } from 'frappe-charts';
dayjs.extend(dayjsUtc);
dayjs.extend(dayjsLocalizedFormat);
export default class StatisticsWidget extends DashboardWidget {
  constructor() {
    super(...arguments);
    _defineProperty(this, "entities", ['users', 'discussions', 'posts']);
    _defineProperty(this, "periods", void 0);
    _defineProperty(this, "chart", void 0);
    _defineProperty(this, "customPeriod", null);
    _defineProperty(this, "timedData", {});
    _defineProperty(this, "lifetimeData", void 0);
    _defineProperty(this, "customPeriodData", {});
    _defineProperty(this, "noData", false);
    _defineProperty(this, "loadingLifetime", true);
    _defineProperty(this, "loadingTimed", this.entities.reduce((acc, curr) => {
      acc[curr] = 'unloaded';
      return acc;
    }, {}));
    _defineProperty(this, "loadingCustom", this.entities.reduce((acc, curr) => {
      acc[curr] = 'unloaded';
      return acc;
    }, {}));
    _defineProperty(this, "selectedEntity", 'users');
    _defineProperty(this, "selectedPeriod", void 0);
    _defineProperty(this, "chartEntity", void 0);
    _defineProperty(this, "chartPeriod", void 0);
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    this.loadLifetimeData();
  }
  async loadLifetimeData() {
    this.loadingLifetime = true;
    m.redraw();
    const data = await app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/statistics',
      params: {
        period: 'lifetime'
      }
    });
    this.lifetimeData = data;
    this.loadingLifetime = false;
    m.redraw();
  }
  async loadTimedData(model) {
    this.loadingTimed[model] = 'loading';
    m.redraw();
    try {
      const data = await app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/statistics',
        params: {
          period: 'timed',
          model
        }
      });
      this.timedData[model] = data;
      this.loadingTimed[model] = 'loaded';

      // Create a Date object which represents the start of the day.
      let todayDate = new Date();
      todayDate.setUTCHours(0, 0, 0, 0);
      const today = todayDate.getTime() / 1000;
      this.periods = {
        today: {
          start: today,
          end: today + 86400,
          step: 3600
        },
        last_7_days: {
          start: today - 86400 * 7,
          end: today,
          step: 86400
        },
        previous_7_days: {
          start: today - 86400 * 14,
          end: today - 86400 * 7,
          step: 86400
        },
        last_28_days: {
          start: today - 86400 * 28,
          end: today,
          step: 86400
        },
        previous_28_days: {
          start: today - 86400 * 28 * 2,
          end: today - 86400 * 28,
          step: 86400
        },
        last_12_months: {
          start: today - 86400 * 364,
          end: today,
          step: 86400 * 7
        }
      };
      this.selectedPeriod = 'last_7_days';
    } catch (e) {
      console.error(e);
      this.loadingTimed[model] = 'fail';
    }
    m.redraw();
  }
  async loadCustomRangeData(model) {
    this.loadingCustom[model] = 'loading';
    m.redraw();

    // We clone so we can check that the same period is still selected
    // once the HTTP request is complete and the data is to be displayed
    const range = _objectSpread({}, this.customPeriod);
    try {
      const data = await app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/statistics',
        params: {
          period: 'custom',
          model,
          dateRange: {
            start: range.start,
            end: range.end
          }
        }
      });
      if (JSON.stringify(range) !== JSON.stringify(this.customPeriod)) {
        // The range this method was called with is no longer the selected.
        // Bail out here.
        return;
      }
      this.customPeriodData[model] = data;
      this.loadingCustom[model] = 'loaded';
      m.redraw();
    } catch (e) {
      if (JSON.stringify(range) !== JSON.stringify(this.customPeriod)) {
        // The range this method was called with is no longer the selected.
        // Bail out here.
        return;
      }
      console.error(e);
      this.loadingCustom[model] = 'fail';
    }
  }
  className() {
    return 'StatisticsWidget';
  }
  content() {
    var _this$customPeriod, _this$customPeriod2;
    const loadingSelectedEntity = (this.selectedPeriod === 'custom' ? this.loadingCustom : this.loadingTimed)[this.selectedEntity] !== 'loaded';
    const thisPeriod = loadingSelectedEntity ? null : this.selectedPeriod === 'custom' ? {
      start: (_this$customPeriod = this.customPeriod) == null ? void 0 : _this$customPeriod.end,
      end: (_this$customPeriod2 = this.customPeriod) == null ? void 0 : _this$customPeriod2.end,
      step: 86400
    } : this.periods[this.selectedPeriod];
    if (this.selectedPeriod === 'custom') {
      if (!this.customPeriodData[this.selectedEntity] && this.loadingCustom[this.selectedEntity] === 'unloaded') {
        this.loadCustomRangeData(this.selectedEntity);
      }
    } else {
      if (!this.timedData[this.selectedEntity] && this.loadingTimed[this.selectedEntity] === 'unloaded') {
        this.loadTimedData(this.selectedEntity);
      }
    }
    return m("div", {
      className: "StatisticsWidget-table"
    }, m("div", {
      className: "StatisticsWidget-entities"
    }, m("div", {
      className: "StatisticsWidget-labels"
    }, m("div", {
      className: "StatisticsWidget-label"
    }, app.translator.trans('flarum-statistics.admin.statistics.total_label')), m("div", {
      className: "StatisticsWidget-label"
    }, loadingSelectedEntity ? m(LoadingIndicator, {
      size: "small",
      display: "inline"
    }) : m(SelectDropdown, {
      disabled: loadingSelectedEntity,
      buttonClassName: "Button Button--text",
      caretIcon: "fas fa-caret-down"
    }, Object.keys(this.periods).map(period => m(Button, {
      key: period,
      active: period === this.selectedPeriod,
      onclick: this.changePeriod.bind(this, period),
      icon: period === this.selectedPeriod ? 'fas fa-check' : true
    }, app.translator.trans("flarum-statistics.admin.statistics.".concat(period, "_label")))).concat([m(Button, {
      key: "custom",
      active: this.selectedPeriod === 'custom',
      onclick: () => {
        const attrs = {
          onModalSubmit: dates => {
            if (JSON.stringify(dates) === JSON.stringify(this.customPeriod)) {
              // If same period is selected, don't reload data
              return;
            }
            this.customPeriodData = {};
            Object.keys(this.loadingCustom).forEach(k => this.loadingCustom[k] = 'unloaded');
            this.customPeriod = dates;
            this.changePeriod('custom');
          }
        };

        // If we have a custom period set already,
        // let's prefill the modal with it
        if (this.customPeriod) {
          attrs.value = this.customPeriod;
        }
        app.modal.show(StatisticsWidgetDateSelectionModal, attrs);
      },
      icon: this.selectedPeriod === 'custom' ? 'fas fa-check' : true
    }, this.selectedPeriod === 'custom' ? extractText(app.translator.trans("flarum-statistics.admin.statistics.custom_label_specified", {
      fromDate: dayjs.utc(this.customPeriod.start * 1000).format('ll'),
      toDate: dayjs.utc(this.customPeriod.end * 1000).format('ll')
    })) : app.translator.trans("flarum-statistics.admin.statistics.custom_label"))])))), this.entities.map(entity => {
      const totalCount = this.loadingLifetime ? app.translator.trans('flarum-statistics.admin.statistics.loading') : this.getTotalCount(entity);
      const thisPeriodCount = loadingSelectedEntity ? app.translator.trans('flarum-statistics.admin.statistics.loading') : this.getPeriodCount(entity, thisPeriod);
      const lastPeriodCount = this.selectedPeriod === 'custom' ? null : loadingSelectedEntity ? app.translator.trans('flarum-statistics.admin.statistics.loading') : this.getPeriodCount(entity, this.getLastPeriod(thisPeriod));
      const periodChange = loadingSelectedEntity || lastPeriodCount === 0 || lastPeriodCount === null ? 0 : (thisPeriodCount - lastPeriodCount) / lastPeriodCount * 100;
      return m("button", {
        className: classList('Button--ua-reset StatisticsWidget-entity', {
          active: this.selectedEntity === entity
        }),
        type: "button",
        onclick: this.changeEntity.bind(this, entity)
      }, m("h3", {
        className: "StatisticsWidget-heading"
      }, app.translator.trans('flarum-statistics.admin.statistics.' + entity + '_heading')), m("div", {
        className: "StatisticsWidget-total",
        title: totalCount
      }, this.loadingLifetime ? m(LoadingIndicator, {
        display: "inline"
      }) : abbreviateNumber(totalCount)), m("div", {
        className: "StatisticsWidget-period",
        title: thisPeriodCount
      }, loadingSelectedEntity ? m(LoadingIndicator, {
        display: "inline"
      }) : abbreviateNumber(thisPeriodCount), periodChange !== 0 && m('[', null, ' ', m("span", {
        className: 'StatisticsWidget-change StatisticsWidget-change--' + (periodChange > 0 ? 'up' : 'down')
      }, m(Icon, {
        name: 'fas fa-arrow-' + (periodChange > 0 ? 'up' : 'down')
      }), Math.abs(periodChange).toFixed(1), "%"))));
    })), m('[', null, loadingSelectedEntity ? m("div", {
      key: "loading",
      className: "StatisticsWidget-chart",
      "data-loading": "true"
    }, m(LoadingIndicator, {
      size: "large"
    })) : m("div", {
      key: "loaded",
      className: "StatisticsWidget-chart",
      "data-loading": "false",
      oncreate: this.drawChart.bind(this),
      onupdate: this.drawChart.bind(this)
    })), this.noData && m(Placeholder, {
      text: app.translator.trans("flarum-statistics.admin.statistics.no_data")
    }), !this.noData && !!this.chart && m(Button, {
      className: "StatisticsWidget-chartExport Button",
      icon: "fas fa-file-export",
      onclick: () => {
        this.chart.export();
      }
    }, app.translator.trans('flarum-statistics.admin.statistics.export_chart_button')));
  }
  drawChart(vnode) {
    var _this$customPeriod3, _this$customPeriod4;
    if (this.chart && this.chartEntity === this.selectedEntity && this.chartPeriod === this.selectedPeriod) {
      return;
    }
    const period = this.selectedPeriod === 'custom' ? {
      start: (_this$customPeriod3 = this.customPeriod) == null ? void 0 : _this$customPeriod3.start,
      end: (_this$customPeriod4 = this.customPeriod) == null ? void 0 : _this$customPeriod4.end,
      step: 86400
    } : this.periods[this.selectedPeriod];
    const periodLength = period.end - period.start;
    const labels = [];
    const thisPeriod = [];
    const lastPeriod = [];
    for (let i = period.start; i < period.end; i += period.step) {
      let label;
      if (period.step < 86400) {
        label = dayjs.unix(i).utc().format('h A');
      } else {
        label = dayjs.unix(i).utc().format('D MMM');
        if (period.step > 86400) {
          label += ' - ' + dayjs.unix(i + period.step - 1).utc().format('D MMM');
        }
      }
      labels.push(label);
      thisPeriod.push(this.getPeriodCount(this.selectedEntity, {
        start: i,
        end: i + period.step
      }));
      lastPeriod.push(this.getPeriodCount(this.selectedEntity, {
        start: i - periodLength,
        end: i - periodLength
      }));
    }
    if (thisPeriod.length === 0) {
      this.noData = true;
      m.redraw();
      return;
    } else {
      this.noData = false;
      m.redraw();
    }
    const datasets = [{
      name: extractText(app.translator.trans('flarum-statistics.admin.statistics.current_period')),
      values: thisPeriod
    }, {
      name: extractText(app.translator.trans('flarum-statistics.admin.statistics.previous_period')),
      values: lastPeriod
    }];
    const data = {
      labels,
      datasets
    };

    // If the dom element no longer exists, recreate the chart
    // https://stackoverflow.com/a/2620373/11091039
    if (!this.chart || !(document.compareDocumentPosition(this.chart.parent) & 16)) {
      this.chart = new Chart(vnode.dom, {
        data,
        type: 'line',
        height: 280,
        axisOptions: {
          xAxisMode: 'tick',
          yAxisMode: 'span',
          xIsSeries: true
        },
        lineOptions: {
          hideDots: 1,
          regionFill: 1
        },
        colors: [app.forum.attribute('themePrimaryColor'), 'black']
      });
    } else {
      this.chart.update(data);
    }
    this.chartEntity = this.selectedEntity;
    this.chartPeriod = this.selectedPeriod;
  }
  changeEntity(entity) {
    this.selectedEntity = entity;
  }
  changePeriod(period) {
    this.selectedPeriod = period;
  }
  getTotalCount(entity) {
    return this.lifetimeData[entity];
  }
  getPeriodCount(entity, period) {
    const timed = (this.selectedPeriod === 'custom' ? this.customPeriodData : this.timedData)[entity];
    let count = 0;
    for (const t in timed) {
      const time = parseInt(t);
      if (time >= period.start && time < period.end) {
        count += timed[time];
      }
    }
    return count;
  }
  getLastPeriod(thisPeriod) {
    return {
      start: thisPeriod.start - (thisPeriod.end - thisPeriod.start),
      end: thisPeriod.start
    };
  }
}
flarum.reg.add('flarum-statistics', 'admin/components/StatisticsWidget', StatisticsWidget);